
import VueSlider from "vue-slider-component/dist-css/vue-slider-component.umd.min.js";
import "vue-slider-component/dist-css/vue-slider-component.css";
import "~/assets/calculator-slider-styles.css";
export default {
  props: ["url", "cta", "type"],
  components: { VueSlider },
  data() {
    return {
      plans: {},
      calculator: {},
      finalPrice: 0,
      test: false,
    };
  },
  computed: {
    thePlans() {
      if (!this.plans.capacity?.length) return [];
      return this.plans.capacity.filter((x) => {
        return x.min < x.max;
      });
    },
  },
  async fetch() {
    this.plans = (await this.$axios.$get(this.url)).data;
    this.plans.capacity.forEach((x) => {
      this.calculator[x.en_title] = x.min;
    });
    this.changePrice();
  },
  methods: {
    changePrice() {
      var items = Object.keys(this.calculator);
      var price = 0;

      var efficients = this.plans.capacity.filter((x) => {
        return x.efficient && x.efficient.length > 0;
      });
      efficients?.forEach((x) => {
        x.efficient?.forEach((e) => {
          var t = this.plans.capacity.filter((y) => {
            return y.id == e.dst_capacity;
          })[0];
          var shouldBe = e.number * this.calculator[x.en_title];
          if (t && this.calculator[t.en_title] < shouldBe)
            this.calculator[t.en_title] = shouldBe;
        });
      });
      items.forEach((x) => {
        let capacity = this.plans.capacity.filter((s) => {
          return s.en_title == x;
        })[0];

        price += this.calculator[x] * +capacity?.price;
        // * (x.toLowerCase() === 'traffic' ? 1 : this.plans?.dictionary[0]?.parameters?.VPS_VPC_RATE || 1)
        this.calculateDiscount(capacity, this.calculator[x]);
      });

      this.finalPrice = Math.round(price);

      // this.finalPrice -= (this.calculator['Traffic'] * this.plans?.capacity.find(x=> x.en_title === 'Traffic').price) * this.plans?.dictionary[0]?.parameters?.VPS_VPC_RATE
    },

    calculateDiscount(capacity, bound) {
      const discount = capacity.discount.filter(
        (x) => x.lower_bound <= bound && x.upper_bound >= bound
      )[0];
      return 1 - (discount?.percent || 0);
    },
  },
  mounted() {
    var sliderElements = document.querySelectorAll(".vue-slider-dot-hover");
    sliderElements.forEach(function (sliderElement) {
      sliderElement.setAttribute("aria-label", "Calculator");
    });
  },

  filters: {
    numberWithCommas(x) {
      return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0;
    },
  },
};
